import { render, staticRenderFns } from "./CreatorColumns.vue?vue&type=template&id=530a2300&scoped=true"
import script from "./CreatorColumns.vue?vue&type=script&lang=js"
export * from "./CreatorColumns.vue?vue&type=script&lang=js"
import style0 from "./CreatorColumns.vue?vue&type=style&index=0&id=530a2300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a2300",
  null
  
)

export default component.exports